<template>
  <v-app>
    <v-main>
      <div class="marcoInicial">
        <router-view />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import { useRouter } from "vue-router";
import { watch } from 'vue'


export default {
  name: 'App',
  setup() {
    const route = useRouter();
    return {
      // route,
    };
  }
}

</script>

